import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { fetchHiredlyXContent } from "../../../redux/actions/company_action";
import { GridStyledTagline } from "./styles";

let query = `
  imageBanner{
      desktopBanner {
        data {
          attributes {
            url
          }
        }
      }
        tabletBanner {
        data {
          attributes {
            url
          }
        }
      }
     mobileBanner{
        data {
          attributes {
            url
          }
        }
      }
  }
`;

export default function HXImageBanner(props) {
  const {} = props;
  const [tagline, setTagline] = useState([]);

  const dispatch = useDispatch();

  async function fetchData() {
    const response = await dispatch(fetchHiredlyXContent(query));

    const { imageBanner } = response || {};

    setTagline(imageBanner);
  }
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <GridStyledTagline
        backgroundImage={tagline?.desktopBanner?.data?.attributes?.url}
      ></GridStyledTagline>
    </>
  );
}
